<template>
    <div>
        <BodycheckPaibantiem />
    </div>
</template>

<script>
import BodycheckPaibantiem from "./bodycheckPaibantiemView.vue";
export default {
    components: {
        BodycheckPaibantiem,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
